import React from 'react';
import { Box, Typography, Paper, Grid2 as Grid, alpha, Stack, Divider } from '@mui/material';
import { NotificationsActiveOutlined, NotificationsNoneOutlined } from '@mui/icons-material';
import NotificationForm from './NotificationForm';
import './style.css';

const NotificationConfig = () => {
  return (
    <Box sx={{ p: { xs: 1, md: 2 }, bgcolor: '#F4F6F8', minHeight: '100vh' }}>
      <Paper
        elevation={0}
        sx={{ p: 3, mb: 3, borderRadius: '16px', border: '1px solid', borderColor: 'divider' }}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Box>
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Box
                sx={{
                  p: 1,
                  borderRadius: '10px',
                  bgcolor: alpha('#1976d2', 0.1),
                  color: 'primary.main',
                  display: 'flex',
                }}
              >
                <NotificationsNoneOutlined fontSize="small" />
              </Box>
              <Typography variant="h5" fontWeight={700}>
                Nofitication
              </Typography>
            </Stack>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Manage Notification accross the system
            </Typography>
          </Box>
        </Stack>
      </Paper>

      <Paper
        elevation={0}
        sx={{ p: 3, mb: 3, borderRadius: '16px', border: '1px solid', borderColor: 'divider' }}
      >
        <NotificationForm />
      </Paper>
    </Box>
  );
};

export default NotificationConfig;
